if (!customElements.get('events-carousel')) {
  class EventsCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiperInit();
    }

    swiperInit() {
      const carousel = this.querySelector('[data-swiper]');

      if (!carousel) { return; }

      const swiper = new window.Swiper(carousel, {
        spaceBetween: 16,
        slidesPerView: 'auto',
        draggable: true,
        loop: true
      });

      return swiper;
    }
  }

  customElements.define('events-carousel', EventsCarousel);
}